import React from 'react';
import type { RatingType } from 'reducers/workout/types';
import QuestionHeader from './QuestionHeader';
import { RatingCard, RatingDescription, RatingLabel, Tone, TwoColumnGrid } from './styles';

export type RatingOption = { value: number; name: string; description: string };

export type Rating = {
  type: RatingType;
  label: string;
  title: string;
  instruction: string;
  phase: number;
  options: RatingOption[];
};

type Props = {
  rating: Rating;
  /** Rating values in the order to show them. */
  displayOrder: number[];
  value?: number;
  context?: string;
  tone?: Tone;
  onSelect: (value: number) => void;
};

export const RatingCards = ({
  rating,
  displayOrder,
  value,
  tone,
  onSelect,
}: Omit<Props, 'context'>) => {
  const options = displayOrder
    .map((optionValue) => rating.options.find((option) => option.value === optionValue))
    .filter((option): option is RatingOption => Boolean(option));

  return (
    <TwoColumnGrid role="group" aria-label={rating.label}>
      {options.map((option) => (
        <RatingCard
          key={option.value}
          type="button"
          $tone={tone}
          aria-pressed={value === option.value}
          onClick={() => onSelect(option.value)}
        >
          <RatingLabel>{option.name}</RatingLabel>
          <RatingDescription>{option.description}</RatingDescription>
        </RatingCard>
      ))}
    </TwoColumnGrid>
  );
};

const RatingQuestion = ({ context, ...cards }: Props) => (
  <>
    <QuestionHeader
      title={cards.rating.title}
      instruction={cards.rating.instruction}
      context={context}
      tone={cards.tone}
    />
    <RatingCards {...cards} />
  </>
);

export default RatingQuestion;
